import * as R from 'ramda';
import React from 'react';
import { Card, Col } from 'antd';
import { ElectronicSignature } from './components';

const useSignatureInfo = (contract) => {
  const getIsSignatureStatus = (contract, status) => {
    return R.includes(R.prop('status', contract), status);
  };

  const isSentForSignature = getIsSignatureStatus(contract, ['sentForSignature', 'sentForSignatureDelayed']);
  const isSigned = getIsSignatureStatus(contract, ['confirmed', 'sentToManagementSystem', 'confirmedInManagementSystem', 'rejectedByManagementSystem', 'confirmedInManagementSystemReopened']);
  const isElectronic = R.pathEq(['signature', 'type'], 'electronic', contract);

  return {
    electronicSignatureId: R.pathOr(null, ['signature', 'id'], contract),
    isSentForSignature,
    isSigned,
    isElectronic
  };
};

const ContractSignatureInfo = ({
  contract
}) => {
  const {
    isSentForSignature,
    isSigned,
    isElectronic,
    electronicSignatureId
  } = useSignatureInfo(contract);

  if (R.isNil(electronicSignatureId)) {
    return null;
  }

  if (!isSentForSignature && !isSigned) {
    return null;
  }

  return <Col span={12}>
    <Card style={{ marginTop: '8px' }} size="small" title="Information sur la signature">
      {isSentForSignature && (
        <div>
          {`Le contrat n'a pas encore été signé ${isElectronic ? 'électroniquement' : 'manuellement'}.`}
        </div>
      )}

      {isSigned && (
        <div>
          {`Le contrat est signé ${isElectronic ? 'électroniquement' : 'manuellement'}`}
        </div>
      )}

      {isElectronic && (
        <ElectronicSignature
          contract={contract}
          isSigned={isSigned}
        />
      )}
    </Card>
  </Col>;
};

export default ContractSignatureInfo;
